import {
  QueryBuilderInputContextType,
  QueryBuilderTypingCommitActionType,
} from '../../types';
import {
  resolveOperandOptionSubmitAction,
  resolveOperatorOrCloseOptionSubmitAction,
  resolveValueOptionSubmitAction,
} from './helpers';

export type ResolveOptionSubmitActionResultType = {
  action: QueryBuilderTypingCommitActionType;
  shouldReopenDropdownAfterSubmit: boolean;
};

export const resolveOptionSubmitAction = (
  context: QueryBuilderInputContextType,
  value: string
): ResolveOptionSubmitActionResultType | null => {
  if (context === 'expectOperand') {
    return resolveOperandOptionSubmitAction(value);
  }

  if (context === 'expectValue') {
    return resolveValueOptionSubmitAction(value);
  }

  if (context === 'expectOperatorOrClose') {
    return resolveOperatorOrCloseOptionSubmitAction(value);
  }

  return null;
};
